import { ApiProperty } from '@nestjs/swagger';
import type { ApiServerEntityIDType } from '../../../types';
import { ImageAsset } from '../../resource/image';
import { ClientPhotoPurpose } from './purpose';

export class ClientPhotoViewModel {
  @ApiProperty()
  id: ApiServerEntityIDType;

  @ApiProperty()
  order: number;

  @ApiProperty()
  isMain: boolean;

  @ApiProperty()
  purpose: ClientPhotoPurpose;

  @ApiProperty()
  notCroppedOriginalSrc?: string;

  @ApiProperty({ type: ImageAsset })
  image: ImageAsset;
}
